'use strict';
import Vue from 'vue';
import apiService from '@/Common/ApiService'
import Utility from '@/Common/Utility'

 

let Sklc = {
     

    GetLawContentFromJson(contentJson) {
        let content = "";
        let dataObject;

        if (
            contentJson.length > 0 &&
            contentJson.trim()[0] == "{"
        ) {
            dataObject = JSON.parse(contentJson);
            content = this.RenderContentByObject(dataObject);
        }
        else {
            content = contentJson;
        }

        return content;
    },


    RenderContentByObject(dataObject) {
        let content = "";


        if (dataObject.content != null) {
            content +=
                `<div class='Content'>${dataObject.content}</div>`;               
        }

        if (dataObject.list != null) {
            //content += "<div class='ChapterList'>";

            if (dataObject.content != null && dataObject.content != "") {
                content += "\r\n";
            }

            dataObject.list.forEach(
                function (childObject) {

                    if (dataObject.content != null && dataObject.content != "") {
                        content += "    ";
                    }

                    content += this.RenderContentByObject(childObject) + "\r\n";
                }.bind(this)
            );

            //content += "</div>";
        }
        else if (dataObject.child != null) {
            content += this.RenderContentByObject(dataObject.child);// + "\r\n";
        }

        return content;
    },


    PrepareNewComplianceRoleStaffInfo: function (divisionId, divisionComplianceRoleNo) {
        let newStaffInfo = {
            StartDate: null,
            CurrentOrPrevStaff: null,
            NewStartDateEnabled: true,
            PrevEndDateEnabled:false,
            DefaultNewStartDate: null,
            MinNewStartDate: null,
            ExtraMessage: "",
            LatestLog: null,
            
        };


        return apiService.Post("/api/DivisionComplianceStaff/GetComplianceStaffInfo",
            {
                DivisionId: divisionId,
                DivisionComplianceRoleNo: divisionComplianceRoleNo
            }
        ).then(
            function (responseData) {
                let validated = true;
                let validationMessage = "";
                let latestLog = null;
                let defaultNewStartDate = null;
                let minNewStartDate = null;
                let newStartDateEnabled = false;
                let prevEndDateEnabled = false;
                let extraMessage = "";
 

                if (responseData.ComplianceStaffLogs.length > 0) {
                    latestLog = responseData.ComplianceStaffLogs[0];

                    responseData.ComplianceStaffLogs.forEach(
                        function (row) {
                            if (row.StartDate != null) {
                                row.StartDate = Utility.ConvertIso8601TextToDate(row.StartDate);
                            }

                            if (row.EndDate != null) {
                                row.EndDate = Utility.ConvertIso8601TextToDate(row.EndDate);
                            }
                        }.bind(this)
                    );
                }

                if (responseData.ComplianceStaff != null && responseData.Staff == null) {
                    //法遵人員 StaffId 存在 , 員工主檔找不到 , 視同離職

                    //需檢查 Log 檔中是否已經 標註 此 Staff 離職日

                    if (responseData.ComplianceStaffLogs.length == 0) {
                        validated = false;
                        validationMessage += "找不到歷史人員記錄";
                    }
                    else if (latestLog.StaffId != responseData.ComplianceStaff.StaffId) {
                        validated = false;
                        validationMessage += "最後一筆歷史資料須為 " + responseData.ComplianceStaff.StaffId;
                    }
                    else if (latestLog.EndDate == null) {
                        validated = false;
                        validationMessage += "前任尚未填寫迄日 ";


                        extraMessage = "前任迄日未填 , 須先填寫前任迄日";

                        newStartDateEnabled = false;
                        prevEndDateEnabled = true;
                    }
                    else {
                        //最後一筆歷史資料為 StaffId 的 , 且有寫迄日

                        //新任起日 為最後一筆歷史資料中的迄日+1
                        defaultNewStartDate = new Date();

                        defaultNewStartDate = Utility.AddDays(latestLog.EndDate, 1);
                         
                        newStartDateEnabled = false;
                    }
                }
                else if (responseData.ComplianceStaff == null && responseData.Staff == null) {
                    //從缺 或尚未指派此法遵角色

                    if (responseData.ComplianceStaffLogs.length == 0) {
                        //沒有歷史紀錄
                        minNewStartDate = null;

                        newStartDateEnabled = true;
                        prevEndDateEnabled = false;

                        extraMessage = "無現任人員，也無歷史紀錄，首次指派，無日期限制";

                    }
                    else if (responseData.ComplianceStaffLogs.length > 0) {

                        //有歷史紀錄 但此人 迄日未填
                        if (latestLog.EndDate == null) {
                            validated = false;
                            validationMessage += "歷史紀錄 , 尚未填寫迄日 !";

     

                            extraMessage = "前任迄日未填 , 須先填寫前任迄日";

                            newStartDateEnabled = false;
                            prevEndDateEnabled = true;
                        }
                        else {
                            //新任起日 為最後一筆歷史資料之迄日+1
                            defaultNewStartDate = new Date();

                            defaultNewStartDate = Utility.AddDays(latestLog.EndDate, 1);

                            extraMessage = "前任迄日(" + Utility.GetDateText(latestLog.EndDate) + ") 已填 , 新任起日為前任迄日+1";

                            newStartDateEnabled = false;
                            prevEndDateEnabled = false;

                        }
                    }

                }
                else if (responseData.ComplianceStaff != null && responseData.Staff != null) {
                    //單純指派換人 員工都存在主檔

                    if (responseData.ComplianceStaffLogs.length == 0) {
                        //歷史不存在 
                        validated = false;
                        validationMessage += "找不到歷史人員記錄";


                        newStartDateEnabled = true;//新任任職日期 無限制
                        prevEndDateEnabled = false;
                    }
                    else if (latestLog.StaffId != responseData.ComplianceStaff.StaffId) {
                        validated = false;
                        validationMessage += "最後一筆歷史資料須為 " + responseData.ComplianceStaff.StaffId;

                        //資料錯誤
                    }
                    else if (latestLog.EndDate != null) {
                        //迄日已被法遵室預填
                        defaultNewStartDate = new Date();
                         
                        defaultNewStartDate = Utility.AddDays(latestLog.EndDate, 1);
                       
                        extraMessage = "前任迄日(" + Utility.GetDateText(latestLog.EndDate) + ") 已填 , 新任起日為 前任迄日+1";

                        newStartDateEnabled = false;
                        prevEndDateEnabled = false;
                    }
                    else {
                        //歷史資料最後一筆的 迄日未填 
                        defaultNewStartDate = new Date();

                        //但起日一定已經填了
                        minNewStartDate = new Date();
             
                        defaultNewStartDate = new Date();

                        //minNewStartDate = Utility.AddDays(latestLog.StartDate, 1);
                        minNewStartDate = new Date();

                        extraMessage = "一般情況 , 更換法遵人員";

                        //newStartDateEnabled = true;
                        newStartDateEnabled = true;
                        prevEndDateEnabled = false;
                    }
                }


                newStaffInfo.DefaultNewStartDate  = defaultNewStartDate;
                newStaffInfo.MinNewStartDate = minNewStartDate;
                newStaffInfo.NewStartDateEnabled = newStartDateEnabled;
                newStaffInfo.Validated = validated;
                newStaffInfo.ValidationMessage = validationMessage;
                newStaffInfo.ExtraMessage = extraMessage;
                newStaffInfo.LatestLog = latestLog;
                newStaffInfo.PrevEndDateEnabled = prevEndDateEnabled;

                return Promise.resolve(newStaffInfo);
            }.bind(this)
        );


        return apiService.Post("/api/DivisionComplianceStaff/Detail",
            {
                DivisionId: divisionId,
                DivisionComplianceRoleNo: divisionComplianceRoleNo
            }
        ).then(
            function (responseData) {
                 
                if (responseData.StaffId != null) {

                     
                    //現任存在
                    let currentStaff = responseData;

                    newStaffInfo.CurrentOrPrevStaff = responseData;

                    return apiService.Post("/api/DivisionComplianceStaffLog/GetLatest",
                        {
                            DivisionId: responseData.DivisionId,
                            DivisionComplianceRoleNo: responseData.DivisionComplianceRoleNo,
                        }
                    ).then(
                        function (responseLatestStaffLog) {
                            let newStartDate = "";


                            if (responseLatestStaffLog.StaffId == currentStaff.StaffId) {
                                newStaffInfo.CurrentOrPrevStaff = responseData;
                            }
                            else {
                                //資料錯誤
                                newStaffInfo.CurrentOrPrevStaff = null;
                            }


                            if (responseLatestStaffLog.StaffId == currentStaff.StaffId) {

                                if (responseLatestStaffLog.EndDate != null && responseLatestStaffLog.EndDate != "") {
                                    //現任有迄日
                                    newStartDate = Utility.ConvertIso8601TextToDate(responseLatestStaffLog.EndDate);

                                    newStartDate = Utility.AddDays(newStartDate, 1);
                                }
                                else {
                                    //現任無迄日

                                    //設為今日
                                    newStartDate = new Date();
                                }
                            }
                            else {
                                //錯誤 : DivisionComplianceStaffLog 最後一筆 並非 現任 !

                                Utility.ShowValidationMessage("錯誤 : DivisionComplianceStaffLog 最後一筆 並非 現任 !");

                                throw "錯誤 : DivisionComplianceStaffLog 最後一筆 並非 現任 !";
                            }

                            return Promise.resolve(newStartDate);
                        }.bind(this)
                    ).then(
                        function (newStartDate) {
                            newStartDate = Utility.RemoveDatePart(newStartDate);

                            newStaffInfo.StartDate = newStartDate;

                            return Promise.resolve(newStaffInfo);
                        }.bind(this)
                    );
                }
                else {
                    //現任不存在

                    //一樣取 Log 最後一筆 , 該筆應為 前任
                    return apiService.Post("/api/DivisionComplianceStaffLog/GetLatest",
                        {
                            DivisionId: divisionId,
                            DivisionComplianceRoleNo: divisionComplianceRoleNo,
                        }
                    ).then(
                        function (responseLatestStaffLog) {
                            let newStartDate = "";

                            if (responseLatestStaffLog.StaffId != null) {
                                newStaffInfo.CurrentOrPrevStaff = responseLatestStaffLog;
                            }
                            else {
                                newStaffInfo.CurrentOrPrevStaff = null;
                            }

                            if (responseLatestStaffLog.StaffId != null) {
                                //有前任

                                if (responseLatestStaffLog.EndDate != null && responseLatestStaffLog.EndDate != "") {
                                    //前任有迄日

                                    //前任迄日+1
                                    newStartDate = Utility.ConvertIso8601TextToDate(responseLatestStaffLog.EndDate);

                                    newStartDate = Utility.AddDays(newStartDate, 1);
                                }
                                else {
                                    //前任無迄日
                                    newStartDate = Utility.GetDateText(new Date());
                                }
                            }
                            else {
                                //沒有前任

                                //設為今日
                                newStartDate = Utility.GetDateText(new Date());
                            }


                            return Promise.resolve(newStartDate);
                        }.bind(this)
                    ).then(
                        function (newStartDate) {
                            newStaffInfo.StartDate = newStartDate;

                            return Promise.resolve(newStaffInfo);
                        }.bind(this)
                    );
                }
            }.bind(this)
        );

       

    },//end PrepareNewComplianceRoleStaffInfo: function (divisionId, divisionComplianceRoleNo) {


    PrepareTrainHours: function (row) {
        let satisfyOtherDivisionTrain = false;
        let satisfyComplianceDivisionTrain = false;
        let otherDivisionRequireTrainHours = 0;
        let complianceDivisionRequireTrainHours = 0;
        let finalRequireHours;
        let otherDivisionDescription = "";
        let complianceDivisionDescription = "";
        let isOtherDivisionNew = false;
        let isComplianceDivisionNew = false;
        let finalDescription = "";
        let staffDivisionId = ""
        let isNew = false;


         

        if (row.ValueSet.StaffDivisionId != null) {
            staffDivisionId = row.ValueSet.StaffDivisionId;
        }
        else {
            staffDivisionId = row.ValueSet.DivisionId;
        }



        if (row.ValueSet.DivisionComplianceRoleNo == 6) {
            //防洗專責主管 , 法遵室特有
            if (row.ValueSet.PrevTotalTrainHours >= 24) {
                //舊任 法遵室 防洗專責主管
                satisfyOtherDivisionTrain = true;
                complianceDivisionRequireTrainHours = 12;
                complianceDivisionDescription = "舊任 防洗專責主管"
                isComplianceDivisionNew = false;

            }
            else {
                //新任 法遵室 防洗專責主管
                complianceDivisionRequireTrainHours = 24;
                complianceDivisionDescription = "新任 防洗專責主管"
                isComplianceDivisionNew = true;
            }
        }
        else if (

            staffDivisionId == "11V000" || staffDivisionId == "11V100" || row.ValueSet.DivisionComplianceRoleNo == 7

        ) {
            //法遵人員 
            if (row.ValueSet.PrevTotalTrainHours >= 30) {
                satisfyOtherDivisionTrain = true;
                complianceDivisionRequireTrainHours = 20;
                complianceDivisionDescription = "舊任 法遵人員"
                isComplianceDivisionNew = false;
             }
            else {
                complianceDivisionRequireTrainHours = 30;
                complianceDivisionDescription = "新任 法遵人員"
                isComplianceDivisionNew = true;
            }
        }
        else if (staffDivisionId == "11V200") {
            if (row.ValueSet.PrevTotalTrainHours >= 24) {
                //舊任 法遵室 防洗人員
                satisfyOtherDivisionTrain = true;
                complianceDivisionRequireTrainHours = 12;
                complianceDivisionDescription = "舊任 防洗人員"
                isComplianceDivisionNew = false;

            }
            else {
                //新任 法遵室 防洗人員
                complianceDivisionRequireTrainHours = 24;
                complianceDivisionDescription = "新任 防洗人員"
                isComplianceDivisionNew = true;

            }
        }

        if (row.ValueSet.DivisionComplianceRoleNo == 1  ) {
            //法令遵循主管 角色

            if (row.ValueSet.StartDate != null) {
                let nowSubSixMonth = new Date(new Date().setDate(-180));
                if (typeof (row.ValueSet.StartDate) == "string") {
                    row.ValueSet.StartDate = Utility.ConvertIso8601TextToDate(row.ValueSet.StartDate);
                }

                if (row.ValueSet.PrevTotalTrainHours >= row.ValueSet.NewRequiredTrainHours ||
                    (row.ValueSet.StartDate < nowSubSixMonth)
                ) {
                    satisfyOtherDivisionTrain = true;
                    otherDivisionRequireTrainHours = row.ValueSet.RequiredTrainHours;
                    otherDivisionDescription = "舊任 法令遵循主管";
                    isOtherDivisionNew = false;
                }
                else {
                    satisfyOtherDivisionTrain = false;
                    otherDivisionRequireTrainHours = row.ValueSet.NewRequiredTrainHours;
                    otherDivisionDescription = "新任 法令遵循主管";
                    isOtherDivisionNew = true;
                }
            }

            
        }
        else if (
            row.ValueSet.DivisionComplianceRoleNo == 3 ||
            row.ValueSet.DivisionComplianceRoleNo == 4 ||
            row.ValueSet.DivisionComplianceRoleNo == 5 
        ) {
            //防洗 督導角色主管

            if (typeof (row.ValueSet.StartDate) == "string") {
                row.ValueSet.StartDate = Utility.ConvertIso8601TextToDate(row.ValueSet.StartDate);
            }

            if (row.ValueSet.StartDate != null) {

                let nowSubSixMonth = new Date(new Date().setDate(-180));
                if (row.ValueSet.PrevTotalTrainHours >= row.ValueSet.NewRequiredTrainHours
                    ||
                    (row.ValueSet.StartDate < nowSubSixMonth)
                ) {
                    satisfyOtherDivisionTrain = true;
                    otherDivisionRequireTrainHours = row.ValueSet.RequiredTrainHours;
                    otherDivisionDescription = "舊任 防洗督導主管";
                    isOtherDivisionNew = false;
                }
                else {
                    satisfyOtherDivisionTrain = false;
                    otherDivisionRequireTrainHours = row.ValueSet.NewRequiredTrainHours;
                    otherDivisionDescription = "新任 防洗督導主管";
                    isOtherDivisionNew = true;
                }
            }
        }

         



        if (otherDivisionRequireTrainHours > complianceDivisionRequireTrainHours) {
            finalRequireHours = otherDivisionRequireTrainHours;
            finalDescription = otherDivisionDescription;
            isNew = isOtherDivisionNew;
        }
        else {
            finalRequireHours = complianceDivisionRequireTrainHours;
            finalDescription = complianceDivisionDescription;
            isNew = isComplianceDivisionNew;
        }

        row.ValueSet.FinalRequiredTrainHours  = finalRequireHours;
        row.ValueSet.FinalDescription = finalDescription;
        row.ValueSet.FinalIsNew = isNew;
    },

    PrepareTrainHoursNotInDCS: function (row) {
        let complianceDivisionRequireTrainHours = 0;
        let complianceDivisionDescription = "";
        let isNew = false;

        if (row.ValueSet.DivisionComplianceRoleNo == null)
        {
            if (row.ValueSet.ClassType == '1') {
                if (row.ValueSet.PrevTotalTrainHours >= 30) {
                    // 舊任
                    complianceDivisionRequireTrainHours = 20;
                    complianceDivisionDescription = "舊任 法遵人員";
                    isNew = false;
                } else {
                    // 新任
                    complianceDivisionRequireTrainHours = 30;
                    complianceDivisionDescription = "新任 法遵人員";
                    isNew = true;
                }
            } else if (row.ValueSet.ClassType == '2'){
                if (row.ValueSet.PrevTotalTrainHours >= 24) {
                    //舊任
                    complianceDivisionRequireTrainHours = 12;
                    complianceDivisionDescription = "舊任 防洗人員"
                    isNew = false;
                }
                else {
                    //新任 
                    complianceDivisionRequireTrainHours = 24;
                    complianceDivisionDescription = "新任 防洗人員"
                    isNew = true;
                }
            }
            row.ValueSet.FinalRequiredTrainHours = complianceDivisionRequireTrainHours
            row.ValueSet.FinalDescription = complianceDivisionDescription;
            row.ValueSet.FinalIsNew = isNew;
        }
    },

    GenerateArticleProcessCode: function(row) {
        let processCode = "";
        let noticeId, reactionItemId;


        noticeId = row.ValueSet.NoticeId + "";
        reactionItemId = row.ValueSet.ReactionItemId + "";

        if (noticeId.indexOf("-L-") > 0) {
            processCode = "-L" + reactionItemId + "-";
            processCode = noticeId.replace("-L-", processCode);
        }
        else if (noticeId.indexOf("-P-") > 0) {
            processCode = "-P" + reactionItemId + "-";
            processCode = noticeId.replace("-P-", processCode);

        }
        else if (noticeId.indexOf("-AL-") > 0) {
            processCode = "-AL" + reactionItemId + "-";
            processCode = noticeId.replace("-AL-", processCode);
        }
        else if (noticeId.indexOf("-AP-") > 0) {
            processCode = "-AP" + reactionItemId + "-";
            processCode = noticeId.replace("-AP-", processCode);
        }

        return processCode;
    },
 
    install(Vue, options) {

        Object.defineProperty(Vue.prototype,

            '$sklc', {
            get() {

                if (this.$_sklc== null) {
                    this.$_sklc = Sklc;
                    this.$_sklc.vueComponent = this;
                }

                return this.$_sklc;
            }
        });
    },
}//end let Sklc = {


export default Sklc;

